import { SocketIoConfig } from 'ngx-socket-io';

export const socketConfig: SocketIoConfig = {
  url: 'http://34.31.185.19:9002',
  options: {
    transports: ['websocket'],
    autoConnect: false
  }
};